import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import productQuery from '~/graphql/product.gql';
import customizedProductQuery from '~/graphql/customizedProduct.gql';

var SquareImage = function SquareImage() {
  return import(
  /* webpackChunkName: "square-image" */
  '~/components/atoms/Product/SquareImage.vue');
};

var ThePriceSection = function ThePriceSection() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/ThePriceSection.vue');
};

var CustomProductAddToCart = function CustomProductAddToCart() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/CustomProductAddToCart.vue');
};

export default {
  name: 'CustomizeProduct',
  components: {
    SquareImage: SquareImage,
    ThePriceSection: ThePriceSection,
    CustomProductAddToCart: CustomProductAddToCart
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      aggregatedProduct: null,
      primaryReference: false,
      emptyPrimary: false,
      selectedPrimary: null,
      secondaryReference: false,
      emptySecondary: false,
      selectedSecondary: null,
      mediumLower: true,
      isFoldedDetails: true,
      noneBg: 'https://medias.maisonsdumonde.com/image/upload/v1567524957/patterns/pattern-3.png'
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    currentPayload: function currentPayload() {
      return {
        primaryTitle: this.payload.primary.primary_label || '',
        primaryProducts: this.catalog.primary || [],
        secondaryTitle: this.payload.primary.secondary_label || '',
        secondaryProducts: this.catalog.secondary || []
      };
    },
    customName: function customName() {
      var result = [];

      if (this.selectedPrimary) {
        result.push(this.selectedPrimary.name);
      }

      if (this.selectedSecondary) {
        result.push(this.selectedSecondary.name);
      }

      return result.length > 1 ? result.join(' + ') : result[0];
    },
    customImage: function customImage() {
      if (this.primaryReference && this.secondaryReference) {
        return "https://medias.maisonsdumonde.com/image/upload/q_auto,f_auto/w_2000/v1567519314/lamp-so-me/".concat(this.secondaryReference, "_").concat(this.primaryReference, ".jpg");
      }

      if (this.primaryReference && !this.secondaryReference) {
        return this.selectedPrimary.images[0].src;
      }

      if (this.secondaryReference && !this.primaryReference) {
        return this.selectedSecondary.images[0].src;
      }

      return 'https://medias.maisonsdumonde.com/image/upload/q_auto,f_auto/w_2000/v1567519314/lamp-so-me/lamp-so-me-empty.jpg';
    }
  }),
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query.primary) {
      this.selectedPrimary = this.currentPayload.primaryProducts.find(function (e) {
        return e.reference === _this.$route.query.primary;
      });

      if (this.selectedPrimary) {
        this.primaryReference = this.selectedPrimary.reference;
      }
    } else {
      var _this$currentPayload$ = _slicedToArray(this.currentPayload.primaryProducts, 1);

      this.selectedPrimary = _this$currentPayload$[0];
      this.primaryReference = this.selectedPrimary.reference;
    }

    if (!this.selectedPrimary) {
      this.emptyPrimary = true;
    }

    if (this.$route.query.secondary) {
      this.selectedSecondary = this.currentPayload.secondaryProducts.find(function (e) {
        return e.reference === _this.$route.query.secondary;
      });

      if (this.selectedSecondary) {
        this.secondaryReference = this.selectedSecondary.reference;
      }
    } else {
      var _this$currentPayload$2 = _slicedToArray(this.currentPayload.secondaryProducts, 1);

      this.selectedSecondary = _this$currentPayload$2[0];
      this.secondaryReference = this.selectedSecondary.reference;
    }

    if (!this.selectedSecondary) {
      this.emptySecondary = true;
    }

    this.customProduct();
    this.mediumLower = !this.isDesktop();
  },
  methods: {
    customProduct: function () {
      var _customProduct = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var references, _ref, product, _ref2, customizedProduct;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                references = [];

                if (this.primaryReference) {
                  references.push(this.primaryReference);
                }

                if (this.secondaryReference) {
                  references.push(this.secondaryReference);
                }

                if (!(references.length === 1)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return this.$apolloProvider.defaultClient.query({
                  query: productQuery,
                  variables: {
                    profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : '',
                    locale: this.locale.iso,
                    reference: references[0],
                    enableCross: false,
                    enableComplementary: false
                  }
                });

              case 6:
                _ref = _context.sent;
                product = _ref.data.product;
                this.aggregatedProduct = product;

              case 9:
                if (!(references.length === 2)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 12;
                return this.$apolloProvider.defaultClient.query({
                  query: customizedProductQuery,
                  variables: {
                    locale: this.locale.iso,
                    references: references
                  }
                });

              case 12:
                _ref2 = _context.sent;
                customizedProduct = _ref2.data.customizedProduct;
                this.aggregatedProduct = customizedProduct;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function customProduct() {
        return _customProduct.apply(this, arguments);
      }

      return customProduct;
    }(),
    clickPrimary: function clickPrimary(product) {
      this.primaryReference = product.reference;
      this.selectedPrimary = product;
      this.emptyPrimary = false;
      this.$router.push({
        query: _objectSpread({
          primary: product.reference
        }, this.$route.query.secondary && {
          secondary: this.$route.query.secondary
        })
      });
      this.customProduct();
    },
    clickEmptyPrimary: function clickEmptyPrimary() {
      this.primaryReference = false;
      this.emptyPrimary = true;
      this.selectedPrimary = null;
      this.$router.push({
        query: _objectSpread({}, this.$route.query.secondary && {
          secondary: this.$route.query.secondary
        })
      });
      this.customProduct();
    },
    clickSecondary: function clickSecondary(product) {
      this.secondaryReference = product.reference;
      this.selectedSecondary = product;
      this.emptySecondary = false;
      this.$router.push({
        query: _objectSpread({
          secondary: product.reference
        }, this.$route.query.primary && {
          primary: this.$route.query.primary
        })
      });
      this.customProduct();
    },
    clickEmptySecondary: function clickEmptySecondary() {
      this.secondaryReference = false;
      this.emptySecondary = true;
      this.selectedSecondary = null;
      this.$router.push({
        query: _objectSpread({}, this.$route.query.primary && {
          primary: this.$route.query.primary
        })
      });
      this.customProduct();
    }
  }
};